var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"focus",rawName:"v-focus"}],ref:"tpicker",staticClass:"tpicker form-control",staticStyle:{"width":"auto"},attrs:{"type":"text","data-date-format":"hh:mm","placeholder":"hh:mm"},domProps:{"value":this.value}})}
var staticRenderFns = []

export { render, staticRenderFns }